import { PlotField } from "../models/PlotField";
import { PlotFieldType } from "../models/PlotFieldType";


export type PlotJsonEditorType = 'object' | 'array' | 'string' | 'number' | 'integer' | 'boolean' | 'null';

export type PlotJsonEditorSchema = {
    type: PlotJsonEditorType
    properties: any
    additionalProperties: boolean,
    minProperties?: number,
    not?: any,
    required: Array<string>
}

export class PlottingJsonPlotConfigurationService {

    public static getJsonEditorSchemaForField(field: PlotField): PlotJsonEditorSchema {
        if (field == null) throw new Error("field is required!");

        const schema: any = {
            properties: {},
            additionalProperties: true
        };

        const schemaType: PlotJsonEditorType | null = this.getSchemaTypeForFieldType(field.field_type);
        if (schemaType !== null) {
            schema.type = schemaType;
        }

        return schema;
    }

    private static getSchemaTypeForFieldType(fieldType: PlotFieldType | any): PlotJsonEditorType | null {

        switch (fieldType) {
            case PlotFieldType.Text:
                return 'string';
            case PlotFieldType.Number:
                return 'number';
            case PlotFieldType.Boolean:
                return 'boolean';
            case PlotFieldType.Array:
            case PlotFieldType.ArrayValues:
                return 'array';
            case PlotFieldType.Object:
            case PlotFieldType.Json:
            case PlotFieldType.StringTemplate:
                return 'object'
            default:
                return null; //Do not limit the schema.type, useful for fields without a valid type defined

        }

    }


    public static getJsonEditorSchemaForPlot(): PlotJsonEditorSchema {
        return {
            type: 'object',
            required: ["type"],
            properties: {
                type: { type: "string" },
                description: { type: "string" }
            },
            additionalProperties: true
        };
    }


}